// Utility function to get environment-specific title
export const getEnvironmentTitle = () => {
  const environment = (process.env.REACT_APP_ENVIRONMENT ||
    (window.location.hostname === 'ithelpdesk.alulatechnologies.com' ? 'production' : 'development')).toLowerCase();

  return environment === 'production' ? 'Alula IT Helpdesk' : 'Alula IT Helpdesk - Dev';
};

// Utility function to get current environment
export const getCurrentEnvironment = () => {
  return process.env.REACT_APP_ENVIRONMENT ||
    (window.location.hostname === 'ithelpdesk.alulatechnologies.com' ? 'production' : 'development');
};
